import { ColDef } from 'ag-grid-community';
import { dateFormatter, dateTimeFormatter } from 'src/app/shared/functions';

export const SalesTableColumnDef: ColDef[] = [
  {
    // ID
    headerName: 'ID',
    field: 'id',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    // Date
    headerName: 'Date',
    field: 'receipt_date',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    valueFormatter: dateFormatter,
  },
  {
    // Type
    headerName: 'Type',
    field: 'type',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
  },
  {
    // Sales Receipt Number
    headerName: 'Sales Receipt Number',
    field: 'sales_receipt_number',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
  {
    // Customer
    headerName: 'Customer',
    field: 'customer_name',
    resizable: true,
    filter: 'agTextColumnFilter',
    width:200,
  },
  {
    // Memo 
    headerName: 'Memo',
    field: 'message_on_statement',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  {
    // Total
    headerName: 'Total',
    field: 'total',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    valueFormatter: function(params) {
      return '$' + params.value.toFixed(2);
    }
  },
  {
    // Status
    headerName: 'Status',
    field: 'status',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    cellRenderer: statusCellRenderer
  }
];


function statusCellRenderer(params) {
  const value = params.value;
  let bgColor = '#6c757d';
  let textColor = '#ffffff';

  if (value === 'Paid') {
    bgColor = 'darkseagreen';
    textColor = '#000000';
  } else if (value === 'Void') {
    bgColor = '#ffc107'; // yellow
    textColor = '#000000';
  }

  return `<span style="background-color: ${bgColor}; color: ${textColor}; padding: 3px 12px; border-radius: 12px; font-size: 0.85em; font-weight: 600; display: inline-block; line-height: 1.2;">${value}</span>`;
}